<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>widgets</mat-icon></div>
          <mat-card-title>Funcionalidades</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          [showSituacao]="true"
          [(situacao)]="situacao"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Clique em <strong>Consultar</strong> para listar as funcionalidades cadastradas.
        </div>

        <table *ngIf="consultaRealizada" mat-table [dataSource]="funcionalidades" class="full-width">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let f">{{ f.id }}</td>
          </ng-container>
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td mat-cell *matCellDef="let f">{{ f.descricao }}</td>
          </ng-container>
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>Value</th>
            <td mat-cell *matCellDef="let f">{{ f.value || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="segmento">
            <th mat-header-cell *matHeaderCellDef>Segmento</th>
            <td mat-cell *matCellDef="let f">{{ f.segmentoNome || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef>Valor</th>
            <td mat-cell *matCellDef="let f">{{ (f.valor || 0) | currency:'BRL':'symbol':'1.2-2' }}</td>
          </ng-container>
          <ng-container matColumnDef="vendaAvulsa">
            <th mat-header-cell *matHeaderCellDef>Venda avulsa</th>
            <td mat-cell *matCellDef="let f">{{ f.vendaAvulsa ? 'Sim' : 'Não' }}</td>
          </ng-container>
          <ng-container matColumnDef="ativa">
            <th mat-header-cell *matHeaderCellDef>Situação</th>
            <td mat-cell *matCellDef="let f">{{ f.ativo !== false ? 'Ativo' : 'Inativo' }}</td>
          </ng-container>
          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let f" (click)="$event.stopPropagation()">
              <button mat-icon-button color="accent" matTooltip="Alterar" (click)="editar(f)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Inativar" (click)="inativar(f)" *ngIf="f.ativo !== false">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['id','descricao','value','segmento','valor','vendaAvulsa','ativa','acoes']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['id','descricao','value','segmento','valor','vendaAvulsa','ativa','acoes'];"
            class="wow-consulta__row" (click)="editar(row)"></tr>
        </table>
      </mat-card>
    </div>
  </div>
</main>
